import { writable } from 'svelte/store';

type WizardState = {
  open: boolean;
  title: string;
  steps: string[];
  currentStep: number;
  componentType: string | null;
  instanceId: string | null;
};

const initialState: WizardState = {
  open: false,
  title: '',
  steps: [],
  currentStep: 1,
  componentType: null,
  instanceId: null,
};

const wizardStore = writable<WizardState>(initialState);

export function openWizard(params: Partial<WizardState>) {
  wizardStore.update(state => ({
    ...state,
    ...params,
    open: true,
    instanceId: crypto.randomUUID()
  }));
}

export function closeWizard() {
  wizardStore.update(state => ({
    ...state,
    open: false,
    componentType: null,
    instanceId: null
  }));
}

export function setStep(step: number) {
  wizardStore.update(state => ({
    ...state,
    currentStep: step
  }));
}

export { wizardStore };
